/* TODO 변경하면 여기 하드코딩 되어있을 환율 변경하면서 생각해보기
    http://redash.data.mp.prod.local/queries/10/source?p_start_date=2024-08-20&p_end_date=2024-10-24&p_%EC%83%B5%EC%9D%B4%EB%A6%84=%EC%A0%84%EC%B2%B4&p_%EB%9D%BC%EB%B2%A8=%EC%A4%91%EC%9A%94%20%EC%9D%B8%EC%8A%A4%ED%83%80#10 */
export const PROFIT_EXCHANGE_RATE_EN = 1 / 1200;
export const PROFIT_EXCHANGE_RATE_JP = 100 / 850;

export const DIGIT = 2;
